<template lang="pug">
  .bonus-rule-page
    //- 顶部导航栏
    .header(v-if="isApp")
      img.back-icon(@click="goBack" src="data:image/svg+xml,%3Csvg width='7' height='14' viewBox='0 0 7 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 1L1 7L6 13' stroke='%23242729' stroke-width='2.5'/%3E%3C/svg%3E" alt="返回")
      span.title 开通奖励金自动抵扣

    //- 主标题
    .main-title
      | 奖励金当钱花
      br
      | 下单默认抵扣

    .switch-box
      //- 开关卡片
      .switch-card
        .card-title 默认自动抵扣订单
        .card-subtitle 内测功能，骑行、顺风车等场景陆续开放中
        .switch-wrapper
          .switch(:class="{ active: isAutoDeduct }" @click="toggleSwitch")
            .switch-circle
      img.rule-page-img(
        src="https://m.hellobike.com/f0540466_image%20664.png"
      )
      img.rule-tip-img(
        src="https://m.hellobike.com/6c8237e7_image%20665.png"
      )

    //- 规则说明
    .rule-text
      | 1、下单时，可在支付页勾选"使用奖励金抵扣"，系统将自动用您的可用奖励金抵扣部分订单金额
      br
      | 2、当前支持非免密支付用户单车、助力车单次骑行抵扣，单车月卡连续包月抵扣功能采用邀请制测试中
      br
      | 3、如不需要使用此功能，可在"福利中心/奖励金→更多→订单默认抵扣→滑动按钮"，即可取消此功能
    //- 底部插图
    .bottom-illustration
</template>

<script>
import Toast from '@/components/toast';
import { env, Native } from '@hb/NBridge/lib/h5';
import { getAutoDeductStatusInfo, updateAutoDeductStatusInfo } from './common/helper';
import {
  debounce,
} from '../../utils';
import SPM from './common/spm';

const PAGE_VIEW_PARAMS = {
  pageId: 'platform_pointsDeduction',
  categoryId: 'platform',
  businessInfo: {},
};

export default {
  name: 'BonusRule',
  data() {
    return {
      isAutoDeduct: false,
      loading: false,
      isApp: env.isEasyBikeApp,
    };
  },
  async created() {
    if (env.isEasyBikeApp) {
      this.hideNav();
    }
  },
  mounted() {
    this.fetchStatus();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    if (env.isEasyBikeApp) {
      this.hideNav();
      setTimeout(() => {
        window.addEventListener('pageshow', () => {
          this.hideNav();
        });
      });
    }
    SPM.pageView(PAGE_VIEW_PARAMS);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        SPM.pageViewOut(PAGE_VIEW_PARAMS);
      } else if (document.visibilityState === 'visible' && env.isEasyBikeApp) {
        this.hideNav();
      }
    },
    hideNav: debounce(() => {
      // eslint-disable-next-line no-undef
      Native.toggleNavBar({ isShow: false }).catch(() => {});
    }),
    // 返回
    goBack() {
      Native.goBack();
    },
    // 获取开关状态
    async fetchStatus() {
      try {
        const {
          isOpen,
          success,
          msg,
        } = await getAutoDeductStatusInfo();
        if (success) {
          this.isAutoDeduct = isOpen;
        } else if (msg) {
          Toast.show(msg);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('获取状态失败', error);
      }
    },
    // 切换开关
    async toggleSwitch() {
      if (this.loading) return;

      this.loading = true;
      const newStatus = !this.isAutoDeduct;

      try {
        const {
          isSuccess,
          success,
          msg,
        } = await updateAutoDeductStatusInfo(newStatus);

        if (success && isSuccess) {
          this.isAutoDeduct = newStatus;
          SPM.clickButton({
            pageId: 'platform_pointsDeduction',
            buttonName: 'platform_pointsDeductionButton',
            categoryId: 'platform',
            businessInfo: {
              changedStatus: newStatus,
            },
          });
        } else if (msg) {
          Toast.show(msg);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('更新状态失败', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bonus-rule-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #ffec8a 0%, #ffe350 100%);
  position: relative;
  padding-top: 0.4rem;
  padding-bottom: 1rem;

  // 顶部导航栏
  .header {
    height: 0.42rem;
    display: flex;
    align-items: center;
    padding: 0 0.16rem;
    position: relative;

    .back-icon {
      width: 0.07rem;
      height: 0.14rem;
      cursor: pointer;
      box-sizing: content-box;
      border: 0.1rem solid transparent;
    }

    .title {
      font-family: PingFang SC, sans-serif;
      font-size: 0.18rem;
      font-weight: 400;
      line-height: 1.4;
      color: #242729;
      margin-left: 0.16rem;
    }
  }

  // 主标题
  .main-title {
    margin: 0.19rem 0 0 0.34rem;
    font-family: vivo Sans SC VF, sans-serif;
    font-size: 0.38rem;
    font-weight: 800;
    line-height: 1.172;
    letter-spacing: -0.0079em;
    color: #000;
  }

  .switch-box {
    position: relative;
    width: 3.52rem;
    height: 3.12rem;
    border-radius: 0.13rem;
    border: 1px solid #fff;
    margin: 0.2rem 0.12rem 0;
    background: rgba(255, 251, 232, 0.3);

    .rule-page-img {
      width: 2.29rem;
      height: 2.22rem;
      margin-top: 0.08rem;
      margin-left: 0.62rem;
    }

    .rule-tip-img {
      width: 3.21rem;
      height: 0.52rem;
      position: absolute;
      bottom: 0.19rem;
      left: 0.15rem;
    }
  }

  // 开关卡片
  .switch-card {
    position: relative;
    padding: 0.16rem 0.17rem 0.12rem 0.2rem;
    background: #fffbe8;
    border-radius: 0.13rem;

    .card-title {
      font-family: PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 600;
      line-height: 0.22rem;
      color: #000;
      margin-bottom: 0.03rem;
    }

    .card-subtitle {
      font-family: PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.17rem;
      color: rgba(0, 0, 0, 0.34);
    }

    .switch-wrapper {
      position: absolute;
      top: 0.2rem;
      right: 0.2rem;
    }

    .switch {
      width: 0.5rem;
      height: 0.3rem;
      background: #d7d7d7;
      border-radius: 0.15rem;
      position: relative;
      cursor: pointer;
      transition: background 0.3s;

      .switch-circle {
        width: 0.28rem;
        height: 0.28rem;
        background: #fff;
        border-radius: 50%;
        position: absolute;
        top: 0.01rem;
        left: 0.01rem;
        transition: left 0.3s;
      }

      &.active {
        background: #fd8103;

        .switch-circle {
          left: 0.21rem;
        }
      }
    }
  }

  // 规则说明
  .rule-text {
    margin: 0.17rem 0.26rem 0;
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 2.167;
    color: #7f3a27;
  }

  // 底部插图
  .bottom-illustration {
    position: absolute;
    bottom: 0.78rem;
    left: 0.34rem;
    width: 3.08rem;
    height: 2.22rem;
    background: url('https://m.hellobike.com/resource/gallery/833/Group%202090054554.png') no-repeat;
    background-size: contain;
    pointer-events: none;
  }
}
</style>
